import React from 'react';
import { Link } from 'react-router-dom';
import { FiUser, FiMail, FiMapPin, FiMessageSquare, FiGithub, FiArrowRight } from 'react-icons/fi';
import '../styles/contact.css';
import config from '../config';

const ContactAndSupportPage = () => {
    const contactMailtoLink = `mailto:${config.supportEmail}?subject=${encodeURIComponent('Inquiry from Electrospinning Data website')}&body=${encodeURIComponent('Hello Electrospinning Data Team,\n\n')}`;

    return (
        <div className="contact-bento-container py-5">
            {/* Header Section */}
            <div className="text-center mb-5 bento-header">
                <h1 className="display-4 font-weight-bold">Let's Connect</h1>
                <p className="lead text-muted">
                    Reach out to the Data Hub team, visit our lab, or join our community.
                </p>
            </div>

            {/* Bento Grid layout */}
            <div className="bento-grid">

                {/* Tile 1: Primary Contact (Wide, Top) */}
                <div className="bento-tile tile-primary">
                    <div className="tile-icon-bg"><FiUser /></div>
                    <div className="tile-content">
                        <span className="tile-label">Direct Contact</span>
                        <h2 className="tile-title">Electrospinning Data Team</h2>
                        <a href={contactMailtoLink} className="bento-link-primary">
                            <FiMail className="me-2" /> {config.supportEmail}
                        </a>
                    </div>
                </div>

                {/* Tile 2: GitHub / Open Source (Square, Top Right) */}
                <div className="bento-tile tile-github">
                    <div className="tile-icon-bg"><FiGithub /></div>
                    <div className="tile-content">
                        <span className="tile-label text-white-50 mb-2 d-block">Open Source</span>
                        <h3 className="tile-title-sm text-white">Contribute on GitHub</h3>
                        <p className="tile-desc text-white-50">View code, report issues, or track our roadmap.</p>
                        <a
                            href={config.githubUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bento-btn bento-btn-light mt-auto"
                        >
                            Repository <FiArrowRight className="ms-2" />
                        </a>
                    </div>
                </div>

                {/* Tile 3: Laboratory Location (Tall, Bottom Left) */}
                <div className="bento-tile tile-location">
                    <div className="tile-icon-bg"><FiMapPin /></div>
                    <div className="tile-content">
                        <span className="tile-label mb-3 d-block">Physical Address</span>
                        <h3 className="tile-title">Research Laboratory for Cognitronics</h3>
                        <div className="address-block mt-3">
                            <p>Thomas Johann Seebeck Department of Electronics</p>
                            <p>Ehitajate tee 5, Room U02B-203</p>
                            <p className="fw-bold mt-2">19086 Tallinn, Estonia</p>
                        </div>
                    </div>
                </div>

                {/* Tile 4: Feedback (Wide, Bottom Right) */}
                <div className="bento-tile tile-feedback">
                    <div className="tile-icon-bg"><FiMessageSquare /></div>
                    <div className="tile-content">
                        <span className="tile-label text-white-50 mb-2 d-block">Community</span>
                        <h3 className="tile-title text-white">We want your feedback</h3>
                        <p className="tile-desc text-white-50">
                            Found a bug? Have a feature idea? Let us know directly.
                        </p>
                        <Link to="/feedbackPage" className="bento-btn bento-btn-accent mt-auto">
                            Submit Feedback <FiArrowRight className="ms-2" />
                        </Link>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ContactAndSupportPage;
